import { render, staticRenderFns } from "./textagreementmanage.vue?vue&type=template&id=0e4f0b16&scoped=true&"
import script from "./textagreementmanage.vue?vue&type=script&lang=js&"
export * from "./textagreementmanage.vue?vue&type=script&lang=js&"
import style0 from "./textagreementmanage.vue?vue&type=style&index=0&id=0e4f0b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f0b16",
  null
  
)

export default component.exports